import { useEffect, useState } from 'react';

interface ExtendedProductsSkeletonCountProps {
  isScrollable: boolean;
  extendedPage: number;
  totalProducts: number;
  loadingExtendedProducts: boolean;
}

interface ExtendedProductsSkeletonCountResult {
  extendedSkeletonItemCount: number;
}

// Returns correct # of skeleton tiles to populate for scrollable extended product rows
const useExtendedProductsSkeletonCount = ({
  isScrollable,
  extendedPage,
  totalProducts,
  loadingExtendedProducts,
}: ExtendedProductsSkeletonCountProps): ExtendedProductsSkeletonCountResult => {
  const [extendedSkeletonItemCount, setExtendedSkeletonItemCount] = useState(0);

  useEffect(() => {
    // If carousel is not scrollable, ensure there are no skeleton items
    if (!isScrollable) {
      if (extendedSkeletonItemCount !== 0) {
        setExtendedSkeletonItemCount(0);
      }

      return;
    }

    // If carousel is scrollable, return appropriate amount of skeleton items
    if (extendedPage === 0) {
      setExtendedSkeletonItemCount(
        totalProducts - 6 <= 12 ? totalProducts - 6 : 12,
      );
    } else if (extendedPage === 1 && !loadingExtendedProducts) {
      setExtendedSkeletonItemCount(
        totalProducts - 6 <= 6 ? totalProducts - 12 : 6,
      );
    } else if (extendedPage === 2 && !loadingExtendedProducts) {
      setExtendedSkeletonItemCount(0);
    }
  }, [extendedPage, loadingExtendedProducts, isScrollable]);

  return {
    extendedSkeletonItemCount,
  };
};

export default useExtendedProductsSkeletonCount;
